import { connect } from 'react-redux';

import SignupComponent from './SignupComponent';

import { notifyUser } from '../Main/actions';
import { signup, socialSignup } from './actionCreators';

const form = 'signup';

const mapStateToProps = (state, ownProps) => {
  const branchValues = ownProps?.location?.state || {};
  const initialValues = branchValues.email
    ? { ...branchValues, username: branchValues.email }
    : { ...branchValues, username: null };

  return {
    initialValues,
    branchValues,
    form,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (data) => signup(dispatch, data),
  onSocialSignup: (type, token, data) =>
    socialSignup(dispatch, type, token, data),
  notifyUser: (message) => notifyUser(dispatch, message, false),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignupComponent);
